import { render, staticRenderFns } from "./internReferralView.vue?vue&type=template&id=6ba00630&scoped=true"
import script from "./internReferralView.vue?vue&type=script&lang=js"
export * from "./internReferralView.vue?vue&type=script&lang=js"
import style0 from "./internReferralView.vue?vue&type=style&index=0&id=6ba00630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba00630",
  null
  
)

export default component.exports